<template>
  <div class="session-l">
    <div>
      <div class="member-info flex">
        <div :class="['member-img-div', { 'border': !member.photo }]" width="65"
          @click="togglePopup(true, false, true)">
          <img class="member-img" v-if="member.photo" width="59"
            :src="fit20.storageBaseUrl + '/member/' + member.id + '.png?generation=' + this.member.photo" />
          <img v-if="!member.photo" width="59" :src="fit20.storageBaseUrl + '/member/default_no_b.png'" />
          <img class="session-img-ico" width="20" :src="fit20.storageBaseUrl + '/static/icons/+foto.svg'" />
        </div>
        <div>
          <div class="flex">
            <div class="member-age" v-if="member.birthDate">{{ getAge(member.birthDate) }}
            </div>
            <div class="birthday  flex" v-if="member.birthDate && isBirthday">
              <img width="12ch" :src="fit20.storageBaseUrl + '/static/images/birthday.png'" />
              <div class="member-birthday">{{
                getBirthDate(member.birthDate, fit20.user.language) }}
              </div>
            </div>
          </div>
          <div class="member-name" @click="togglePopup(true, true, false)">{{ member.displayFirstName + `
            `
            + member.displayLastName }}</div>
        </div>

      </div>
      <div class="member-menu-container" @click="showMemberMenu">
        <img :src="fit20.storageBaseUrl + '/static/icons/member-menu.svg'" />
      </div>
      <!-- start the member menu -->
      <div v-if="memberMenu" class="member-menu">
        <div class="menu-header flex">
          <div class="close-member-menu" @click="showMemberMenu"><img width="20"
              :src="fit20.storageBaseUrl + '/static/icons/x-btn.png'" />
          </div>
        </div>
        <div class="member-menu-items">
          <div @click="showMemberReport(true)">{{ $t('member-report') }}</div>
        </div>
      </div>
      <!-- end the member menu -->

      <!-- start member report -->


      <div class="iframe-div popup-overlay flex animated zoomIn" v-if="memberReport">
        <div class='FAQ-popup-title flex'>
          <span>{{ member.displayFirstName }}</span>
          <img width="20px" :src="fit20.storageBaseUrl + '/static/icons/white-x.svg'" @click="showMemberReport" />
        </div>
        <iframe :src="memberReportLink" style="width: 100% !important; height: 95%;  overflow: scroll !important;">
        </iframe>
      </div>


      <!-- end member report -->



      <div :class="['bars animated zoomIn not', { 'display-none': !socket }]">
        <!-- start stationary counter -->
        <div class="stationary-popup-overlay" v-if="showStationary">
          <div>
            <div>
              <div class="stationary-count-down animated zoomIn not">
                {{ stationaryCounter }}
              </div>
            </div>
          </div>
        </div>
        <!-- end stationary counter -->


        <div class="follow-me-container" @click="calibrationPopup(true)">
          <div class="rep-counter animated zoomIn not">
            {{ repCount }}
          </div>
          <div class="follow-me-bar" :style="{ width: followMeBarWidth }" :id="'follow_me_bar' + selectedMember.id">
          </div>
        </div>
        <div class="you-container" @click="calibrationPopup(true)">
          <div class="second-counter animated zoomIn not">
            {{ secondCount }}
          </div>
          <div class="you-bar" :style="{ width: youBarWidth, backgroundColor: youBarBgColor }"
            :id="'you_bar' + selectedMember.id"></div>
        </div>
        <img width="55px" class="blue-cali" :class="{ 'flash': isFlashing }" v-if="isFlashing"
          :src="fit20.storageBaseUrl + '/static/icons/blue%20calibration.svg'">
      </div>

      <!-- start QS section -->
      <div :class="['animated zoomIn not', { 'display-none': !QS }]">
        <QS class="qs-container" :fit20="fit20" :QS="QS" :personalBest="personalBest" :overAllQs="overAllQs"
          :trainingAge="trainingAge" />
        <D3LineChart v-if="QS" :height="60" :config="chart_config" :datum="QS.graphData"></D3LineChart>
        <div class="msg" v-if="msg && !trainingAge">{{ $t(msg) }}</div>
        <!-- start training-age -->
        <!-- <div class="training-age" v-if="QS && trainingAge">
          <div>
            <div>
              <div class="training-age">
                {{ $t('training-age') + ": " + trainingAge }}
              </div>
            </div>
          </div>
        </div> -->
        <!-- end training-age -->
      </div>
      <!-- end QS section -->
      <div :class="['remarks', { 'over-write-remarks-height': socket || QS }]">
        <div class="cali animated zoomIn not" v-if="showCalibrationPopup">
          <div class="cali-img-m">
            <img width="65px" :src="fit20.storageBaseUrl + '/static/icons/start-point.svg'"
              @click="setCalibration(true)" />
            <img width="65px" :src="fit20.storageBaseUrl + '/static/icons/end-point.svg'" @click="setCalibration()" />
          </div>
          <img class="cali-close" width="20px" :src="fit20.storageBaseUrl + '/static/icons/x-btn.png'"
            @click="calibrationPopup()" />
          <div>
            <img class="cali-close-img-m" width="85px"
              :src="fit20.storageBaseUrl + '/static/icons/memberscreen%20weg.svg'" @click="closeSensor()" />
          </div>
        </div>
        <div v-if="selectedMember.remarks && selectedMember.remarks.length > 0">
          <div v-for="remark, index in selectedMember.remarks" :key="('remarks' + selectedMember.id) + index"
            class="remarks-top-m">
            <div class="remarks-title-sec">
              <img class="green-heart" :src="fit20.storageBaseUrl + '/static/icons/green-heart.svg'"
                @click="deleteRemarks(index)" />
              <span class="remarks-title">
                <span class="remarks-type">{{ ' - ' + $t(remark.type) }}</span>
                | {{ formatDate(remark.date, false, true) }}
              </span>
              <img class="pin" v-if="!remark.pin" :src="fit20.storageBaseUrl + '/static/icons/gray-pin.svg'"
                @click="pin(index, true)" />
              <img class="pin" v-if="remark.pin" :src="fit20.storageBaseUrl + '/static/icons/blue-pin.svg'"
                @click="pin(index, false)">
            </div>
            <textarea v-text="remark.text" class="unstyled-textarea remarks-text" ref="remarkTextAreas"
              @input="editRemarks($event, index)"></textarea>
          </div>
        </div>
        <img class="add-remark" :src="fit20.storageBaseUrl + '/static/icons/add.svg'" @click="remarkPopup(true)" />
        <img v-if="isRemarksChanged" class="save-remark" :src="fit20.storageBaseUrl + '/static/icons/save.png'"
          @click="saveRemarks(true)" />
        <div v-if="showRemarksPopup" class="add-remark-popup">
          <div class="remarks-popup-title"><img class="close-popup"
              :src="fit20.storageBaseUrl + '/static/icons/white-x.svg'" @click="remarkPopup(false)" /></div>
          <div class="add-remarks-body">
            <select v-model="remark.type" class="select-remarks">
              <option value="remarks">{{ capitalizeFirstLetter($t('remarks')) }}</option>
              <option value="aims">{{ capitalizeFirstLetter($t('aims')) }}</option>
              <option value="results">{{ capitalizeFirstLetter($t('results')) }}</option>
            </select>
            <textarea class="text-area-remarks" name="" v-model="remark.text" rows="5"></textarea>
          </div>
          <img class="save-remarks-btn" @click="addRemark" :src="fit20.storageBaseUrl + '/static/icons/save.png'" />
        </div>
      </div>
    </div>
    <!-- start edit member photo popup  -->
    <div class="popup-overlay" v-if="showPhotoPopup">
      <Photo :title="member.displayFirstName" :id="member.id" :changePhoto="changePhoto" :savePhoto="savePhoto"
        :togglePopup="togglePopup" :photo="memberPhoto" :fit20="fit20" :togglePopupValues="[false, false, true]"
        :newPhoto="newPhoto" />
    </div>

    <!-- start edit member popup  -->
    <div class="popup-overlay" v-if="showEditMemberPopup">
      <div class="edit-member animated zoomIn">
        <div class='popup-title flex'>
          <span>{{ selectedMember.displayFirstName }}</span>
          <img width="20px" :src="fit20.storageBaseUrl + '/static/icons/white-x.svg'"
            @click="togglePopup(false, true, false)" />
        </div>
        <div class="flex edit-member-body">
          <form class="session-form-container" id="admin_studio_info">
            <div class="flex edit-member-1sec">
              <div class="field-sec">
                <input :placeholder="$t('first-name')" type="text" class="form-control"
                  v-model="selectedMember.displayFirstName" />
              </div>
              <div class="field-sec">
                <input :placeholder="$t('last-name')" type="text" class="form-control"
                  v-model="selectedMember.displayLastName" />
              </div>
              <div class="field-sec date">
                <input type="text" :placeholder="selectedMember.birthDate ? '' : $t('date-of-birth')"
                  class="form-control" readonly />
                <Datepicker ref="datepicker" v-model="selectedMember.birthDate" class="form-control date-picker">
                </Datepicker>
              </div>
              <div class="field-sec">
                <select id="" class="" v-model="selectedMember.gender">
                  <option value="">{{ capitalizeFirstLetter($t('gender')) }}</option>
                  <option value="male">{{ capitalizeFirstLetter($t('male')) }}</option>
                  <option value="female">{{ capitalizeFirstLetter($t('female')) }}</option>
                  <option value="other">{{ capitalizeFirstLetter($t('other')) }}</option>
                </select>
              </div>
              <div class="field-sec">
                <input :placeholder="$t('email')" type="email" class="form-control" v-model="selectedMember.email" />
              </div>
              <div class="field-sec">
                <input :placeholder="$t('phone')" type="text" class="form-control" v-model="selectedMember.phone">
              </div>
              <div class="field-sec">
                <select v-model="selectedMember.language">
                  <option value="">{{ $t('language') }}</option>
                  <option v-for="language in fit20.languages" :value="language.code" :key="language.code">{{
                    language.name
                  }}
                  </option>
                </select>
              </div>
              <div class="field-sec">
                <select class="" v-model="selectedMember.status">
                  <option value="prospect">{{ capitalizeFirstLetter($t('prospect')) }}</option>
                  <option value="exProspect">{{ capitalizeFirstLetter($t('ex-prospect')) }}</option>
                  <option value="member">{{ capitalizeFirstLetter($t('member')) }}</option>
                  <option value="exMember">{{ capitalizeFirstLetter($t('ex-member')) }}</option>
                  <option value="onHold">{{ capitalizeFirstLetter($t('on-hold')) }}</option>
                </select>
              </div>
            </div>
            <div class="field-sec flex">
              <label class="">{{ $t('start-membership') }}</label>
              <input type="date" class="form-control" v-model="selectedMember.startMembership" />
            </div>
            <div class="field-sec flex">
              <label class="">{{ $t('end-membership') }}</label>
              <input type="date" class="form-control" v-model="selectedMember.endMembership" />
            </div>
            <div class="field-sec flex">
              <label>{{ $t('height-in-cm') }}</label>
              <input type="number" class="form-control height" v-model="selectedMember.height">
            </div>
            <div class="field-sec flex">
              <label>{{ $t('weight-in-kg') }}</label>
              <input type="date" class="form-control" v-model="selectedMember.measure[0].date" disabled>
              <input type="number" class="form-control height last-measure-weight" v-model="displayedLastWeight">
            </div>
            <div class="measure-div" v-if="selectedMember.measure.length > 2">
              <div v-for="weight, index in selectedMember.measure">
                <div class="field-sec flex" v-if="index > 0">
                  <label>{{ $t('') }}</label>
                  <span class="measure-date">{{ formatDate(weight.date, true) }}</span>
                  <span class="measure-weight">{{ weight.weight }}</span>
                </div>
              </div>
            </div>
          </form>
          <div>
            <div class="fake-div"></div>
            <div class="btn-container">
              <img class="new-session-btn" width="60px" :src="fit20.storageBaseUrl + '/static/icons/save.png'"
                @click="saveMember">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import isEqual from 'lodash/isEqual';
import Photo from "./Photo.vue";
import QS from "./QS.vue";
import { D3LineChart } from 'vue-d3-charts';
import Datepicker from 'vuejs-datepicker';
import { formattedDateTime, isValidEmail } from "../actions/global.js";
export default {
  name: 'SessionL',
  components: {
    Photo,
    D3LineChart,
    QS, Datepicker,
  },
  props: ["fit20", "selectTab", "selectedMember", "member", "originalMember", "updateLastWeight", "lastWeight",
    "tabNum", "newRemarks", "formatDate", "isChanged", "socket", "closeWebSocket",
    "selectedMachine", "machineSetting", "saveMemberMachineSetting", "repCount", "stationaryCounter", "showStationary",
    "QS", "personalBest", "overAllQs", "msg", "trainingAge", "capitalizeFirstLetter", "secondCount", "youBarWidth", "youBarBgColor", "followMeBarWidth"
  ],
  data() {
    return {
      isFlashing: false,
      cursorPosition: null,
      isRemarksChanged: false,
      newRemarkValue: '',
      displayedLastWeight: 0,
      memberReportLink: '',
      memberReport: false,
      memberMenu: false,
      showCalibrationPopup: false,
      maxDate: this.formatDate(new Date()),
      showEditMemberPopup: false,
      showPhotoPopup: false,
      memberPhoto: "",
      newPhoto: false,
      remark: {
        type: 'remarks',
        text: '',
        date: new Date().toISOString(),
        pin: false
      },
      showRemarksPopup: false,
      chart_config: {
        values: ['ref', 'act'],
        date: {
          key: 'date',
          inputFormat: '%s',
          outputFormat: '%s',
        },
        points: false,
        axis: {
          yTicks: 0,
          // xTicks: 2,
        },
        curve: "curveLinear",
        margin: {
          top: 5,
          right: 0,
          bottom: 0,
          left: 0
        },
        color: {
          scheme: ['#0000002f', '#009FE380']
        },
        transition: {
          ease: 'easeLinear',
          duration: 1000
        }
      },
      chart_data: [

      ],
    };
  },
  computed: {
    isBirthday() {
      if (!this.member.birthDate) return false;

      const birthDate = new Date(this.member.birthDate);
      const today = new Date();

      const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const birthdayThisYear = new Date(today.getFullYear(), birthDate.getMonth(), birthDate.getDate());

      const diffMs = todayMidnight - birthdayThisYear;
      const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

      return diffDays >= -10 && diffDays <= 10;
    }
  },

  methods: {
    adjustHeight(editableElement) {
      editableElement.style.height = "auto"; // Reset height to auto first
      editableElement.style.height = editableElement.scrollHeight == 0 ? "26px" : editableElement.scrollHeight + "px"; // Set height based on content
    },
    getAge(date) {
      const birthDate = new Date(date);
      const today = new Date();

      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();

      // Check if the birthdate has not yet occurred this year
      if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      return age;
    },
    getBirthDate(date, locale = 'en') {
      const birthDate = new Date(date);

      const day = String(birthDate.getDate()).padStart(2, '0');
      const month = String(birthDate.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
      const year = birthDate.getFullYear();

      if (locale == 'en') {
        // MM-DD-YYYY
        return `${month}-${day}-${year}`;
      } else {
        // DD-MM-YYYY
        return `${day}-${month}-${year}`;
      }
    },
    // isBirthday(date) {
    //   const birthDate = new Date(date);
    //   const today = new Date();

    //   // Create clean date objects (at midnight)
    //   const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    //   const birthdayThisYear = new Date(today.getFullYear(), birthDate.getMonth(), birthDate.getDate());

    //   // Calculate days since last birthday
    //   const diffMs = todayMidnight - birthdayThisYear;
    //   const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    //   console.log("Days since last birthday:", diffDays);

    //   // Return true if birthday is today or within last 10 days
    //   return diffDays >= -10 && diffDays <= 10;
    // },

    showMemberMenu() {
      this.memberMenu = !this.memberMenu;
    },
    async showMemberReport(open) {
      this.fit20.isLoaded = false;
      if (open) {
        let data = await fetch(this.fit20.baseUrl + '/api/auth/memberToken/' + this.member.id + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email);
        let token = await data.text();
        if (token.msg) {
          this.fit20.errMsgs.push({ id: Date.now(), type: "err", msg: this.$t(token.msg) });
        } else {
          this.memberReportLink = 'https://myfit20.com/my-progress?id=' + this.member.id + '&api_key=' + token;
        }
      }
      this.fit20.isLoaded = true;
      this.memberReport = !this.memberReport;
      this.memberMenu = false;
    },
    closeSensor: async function () {
      this.closeWebSocket(this.selectedMachine, false);
      this.calibrationPopup();
    },
    setCalibration: async function (start) {
      // check what the new member have in the machine settings  >>>>>>>>>> IMPORTANT 
      try {
        let startCalibration;
        let endCalibration;
        let machineSetting = this.selectedMember.machinesSettings.find(machine => machine.machineId == this.selectedMachine.id && machine.studioId == this.fit20.studio.id)
        if (machineSetting) {
          startCalibration = machineSetting.startCalibration ? machineSetting.startCalibration : 0;
          endCalibration = machineSetting.endCalibration ? machineSetting.endCalibration : 200;
        }
        let machineInStudio = this.fit20.studio.machines.find(machine => machine.id == this.selectedMachine.id || this.selectedMachine.id == '1001' && machine.id == this.fit20.newLegPress);
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 7000);
        let getPosition = await fetch(`${this.fit20.hostProtocol}${machineInStudio.ipAddress}:${this.fit20.MSA_port}/position`, { method: 'GET', signal: controller.signal, });
        let position = await getPosition.json();
        clearTimeout(timeoutId);
        if (start) {
          startCalibration = position.position
          this.fit20.errors.push("New startCalibration : " + this.selectedMachine.name + " of " + this.selectedMember.firstName + " " + startCalibration + " " + formattedDateTime());
        } else {
          endCalibration = position.position
          this.fit20.errors.push("New endCalibration : " + this.selectedMachine.name + " of " + this.selectedMember.firstName + " " + endCalibration + " " + formattedDateTime());
        }
        const data = {
          member: { id: this.selectedMember.id, name: this.selectedMember.displayFirstName + " " + this.selectedMember.displayLastName },
          trackingFactor: 1,
          easingFactor: 1.5,
          calibration: { inStudioId: this.fit20.studio.id, start: startCalibration, end: endCalibration }
        };
        const controller2 = new AbortController();
        const timeoutId2 = setTimeout(() => controller2.abort(), 7000);
        let setConfigure = await fetch(`${this.fit20.hostProtocol}${machineInStudio.ipAddress}:${this.fit20.MSA_port}/configure`, {
          signal: controller2.signal,
          method: 'POST',
          body: JSON.stringify(data), // Convert data to JSON string
        });
        let configure = await setConfigure.json();
        clearTimeout(timeoutId2);
        if (configure) {
          machineSetting.startCalibration = startCalibration;
          machineSetting.endCalibration = endCalibration;
          this.saveMemberMachineSetting(this.selectedMachine.id, true, false)
        }
        this.isFlashing = true;
        setTimeout(() => {
          this.isFlashing = false;
        }, 1000); // 0.5 second flash
      } catch (err) {
        console.log({ err });
        this.fit20.errors.push("Error in SessionL.vue in setCalibration " + formattedDateTime());
        this.fit20.errors.push(JSON.stringify({
          message: err.message,
          stack: err.stack,
          name: err.name,
        }) + " " + formattedDateTime());
        this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: this.$t('Network error!') });
      }
    },
    calibrationPopup: function (open) {
      if (open) {
        this.showCalibrationPopup = true;
      } else {
        this.showCalibrationPopup = false;
      }

    },
    togglePopup: async function (open, member, photo) {
      if (member) {
        this.showEditMemberPopup = !this.showEditMemberPopup;
        if (!open) {
          this.selectedMember = JSON.parse(JSON.stringify(this.originalMember));// make this as function on the original component
        }
      } else if (photo) {
        this.showPhotoPopup = !this.showPhotoPopup;
        this.memberPhoto = this.fit20.storageBaseUrl + "/member/" + (this.member.photo ? this.member.id + ".png?generation=" + this.member.photo : "default.svg");
        this.newPhoto = false;
      }
    },
    changePhoto: function (e) {
      const file = e.target.files[0]; // Get the first selected file
      if (file) {
        // Use FileReader to read the selected file
        const reader = new FileReader();
        reader.onload = (e) => {
          this.memberPhoto = e.target.result; // Set the imageUrl to the data URL
          this.newPhoto = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    savePhoto: async function () {
      if (this.newPhoto) {
        const formData = new FormData();
        formData.append('image', this.newPhoto);
        const res = await fetch(this.fit20.baseUrl + "/api/photos/member/" + this.member.id + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email, {
          method: 'POST',
          body: formData,
        });
        if (res.ok) {
          let photo = await res.json();
          if (photo.msg) {
            if (photo.msg == "invalid-token") {
              this.clearLocalStorage();
            }
            // alert(this.$t(photo.msg));
            this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: this.$t(photo.msg) });
          } else {
            this.member.photo = photo;
          }

        } else {
          this.fit20.errors.push("Error in SessionL.vue in savePhoto " + formattedDateTime());
          this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: this.$t('general-err-msg') });
        }
      }
      this.newPhoto = false;
      this.showPhotoPopup = !this.showPhotoPopup;
    },
    saveMember: async function () {

      if (isEqual(this.selectedMember, this.originalMember) && (this.lastWeight === 0 || (this.selectedMember.measure.length > 0 && this.lastWeight == this.selectedMember.measure[0].weight))) {
        this.fit20.errMsgs.push({ id: Date.now(), type: 'info', msg: this.$t('general-no-changes') });
        this.togglePopup(false, true, false);
        this.showEditMemberPopup = false;
      } else if (!this.selectedMember.displayFirstName) {
        this.fit20.errMsgs.push({ id: Date.now(), type: 'info', msg: this.$t('required-field').replace('{field}', this.$t('first-name')) });
      } else if (this.selectedMember.email && this.selectedMember.email.length > 0 && !isValidEmail(this.selectedMember.email)) {
        this.fit20.errMsgs.push({ id: Date.now(), type: 'info', msg: this.$t('invalid-email') });
      }
      else {
        try {
          let becomeEx;
          if (this.originalMember.status != this.selectedMember.status && (this.selectedMember.status.includes('ex'))) {
            if (confirm(this.$t('exMember-warning').replace('{name}', this.selectedMember.displayFirstName))) {
              // remove all partners // his object , partners object ,in studio members from both members 
              let studioInMember = this.selectedMember.studios.find(studio => studio.id == this.fit20.studio.id);
              if (studioInMember) {
                studioInMember.memberStatus = this.selectedMember.status;
                let currentMemberInStudio = this.fit20.studio.members.find(member => member.id == this.selectedMember.id);
                currentMemberInStudio.status = this.selectedMember.status;
                currentMemberInStudio.partners = [];
                if (studioInMember.partners.length > 0) {
                  studioInMember.partners.forEach(partner => {
                    let partnerInStudio = this.fit20.studio.members.find((member) => member.id == partner.id);
                    if (partnerInStudio) {
                      let partnerToRemove = partnerInStudio.partners.findIndex(
                        (p) => p.id == this.selectedMember.id,
                      );
                      if (partnerToRemove != -1) {
                        partnerInStudio.partners.splice(partnerToRemove, 1);
                      }
                    }
                  });
                }
                studioInMember.partners = [];
                becomeEx = true;
              }
            } else {
              return false;
            }
          }

          let studioInMember = this.selectedMember.studios.find(studio => studio.id == this.fit20.studio.id);
          if (studioInMember) {
            studioInMember.memberStatus = this.selectedMember.status;
            let currentMemberInStudio = this.fit20.studio.members.find(member => member.id == this.selectedMember.id);
            currentMemberInStudio.status = this.selectedMember.status;
          }
          if (this.selectedMember.measure.length > 0 && this.lastWeight != this.selectedMember.measure[0].weight && this.member.measure.length > 0) {
            this.selectedMember.measure.push({
              date: new Date().toISOString(),
              weight: this.lastWeight,
            });
            this.selectedMember.measure = this.selectedMember.measure.filter(m => m.weight != 0);
          } else if (this.member.measure.length < 1) {
            this.selectedMember.measure = [{
              date: new Date().toISOString(),
              weight: this.lastWeight,
            }]
          }
          this.selectedMember.firstName = this.selectedMember.displayFirstName;
          this.selectedMember.lastName = this.selectedMember.displayLastName;
          let updateMember = await fetch(this.fit20.baseUrl + "/api/members/" + this.fit20.user.email + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.selectedMember),
          });
          let updatedMember = await updateMember.json();
          if (updatedMember.msg) {
            if (updatedMember.msg == "invalid-token") {
              this.clearLocalStorage();
            }
            //alert(this.$t(updatedMember.msg));
            this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: this.$t(updatedMember.msg) });
          } else {
            this.fit20.currentMembers.forEach((currentMembers, index) => {
              if (currentMembers[0] && currentMembers[0].id) {
                let memberNeedToUpdateIndex = currentMembers.findIndex((currentMember) => currentMember.id == updatedMember.id)
                if (memberNeedToUpdateIndex != -1) {
                  this.fit20.currentMembers[index][memberNeedToUpdateIndex] = JSON.parse(JSON.stringify(updatedMember));
                  Object.keys(this.member).forEach(key => {
                    this.member[key] = updatedMember[key];
                  })
                }
              }
            });
          }

          this.showEditMemberPopup = false;
          if (becomeEx) {
            this.fit20.studio.memberCount = this.fit20.studio.memberCount - 1;
            let selectedStudio = this.fit20.studios.find(studio => studio.id == this.fit20.studio.id);
            if (selectedStudio) {
              selectedStudio.memberCount = selectedStudio.memberCount - 1;
            }
            this.fit20.currentMembers.splice(this.tabNum, 1);
            this.fit20.currentMembers.push([]);
            this.selectTab('tab_id' + (this.tabNum + 1), 'tab_id' + (this.tabNum + 1));
          }
        } catch (err) {
          console.log({ err });
          this.fit20.errors.push("Error in SessionL.vue in saveMember" + formattedDateTime());
          this.fit20.errors.push(JSON.stringify({
            message: err.message,
            stack: err.stack,
            name: err.name,
          }) + " " + formattedDateTime());
          this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: this.$t('general-err-msg') });
        }
      }
    },
    pin: function (i, pin) {
      this.selectedMember.remarks[i].pin = pin;
      this.newRemarks[i].pin = pin;
      this.selectedMember.remarks = JSON.parse(JSON.stringify(this.newRemarks.sort((a, b) => {
        if (b.pin - a.pin !== 0) {
          return b.pin - a.pin;
        }
        return new Date(b.date) - new Date(a.date);
      })))
      this.saveRemarks();
    },
    remarkPopup: function (show) {
      this.showRemarksPopup = show;
      this.remark.type = "remarks";
      this.remark.text = "";
    },
    editRemarks: function (e, index) {
      this.newRemarkValue = e.target.value
      this.newRemarks[index].text = e.target.value
      this.adjustHeight(e.target);
    },
    deleteRemarks: function (index) {
      this.fit20.alerts.push({
        id: Date.now(),
        type: 'confirmation', // Change type to 'confirmation'
        msg: this.$t('confirm-delete-remark'),
        onConfirm: () => {
          // If user clicks "Continue"
          this.selectedMember.remarks.splice(index, 1);
          this.saveRemarks();
        },
      });
      // if (window.confirm(this.$t('confirm-delete-remark'))) {
      //   this.selectedMember.remarks.splice(index, 1);
      //   this.saveRemarks();
      // }
    },
    addRemark: function () {
      if (this.remark.text.length > 0) {
        this.newRemarks.push(JSON.parse(JSON.stringify(this.remark)));
        this.saveRemarks(true);
      } else {
        this.remark.type = "remarks";
        this.remark.text = "";
      }
      this.showRemarksPopup = false;
    },
    saveRemarks: async function (remarks) {
      try {
        if (remarks) {
          this.selectedMember.remarks = this.newRemarks.sort((a, b) => {
            if (b.pin - a.pin !== 0) {
              return b.pin - a.pin;
            }
            return new Date(b.date) - new Date(a.date);
          });
          this.isRemarksChanged = false;
        }
        let updateMember = await fetch(this.fit20.baseUrl + "/api/members/remarks/" + this.fit20.user.email + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.selectedMember),
        });

        let updatedMember = await updateMember.json();
        if (updatedMember.msg) {
          if (updatedMember.msg == "invalid-token") {
            this.clearLocalStorage();
          }
          // alert(this.$t(updatedMember.msg));
          this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: this.$t(updatedMember.msg) });
        } else {
          this.originalMember.remarks = JSON.parse(JSON.stringify(updatedMember.remarks));
        }
      } catch (err) {
        console.log({ err });
        this.fit20.errors.push("Error in SessionL.vue in saveRemarks" + formattedDateTime());
        this.fit20.errors.push(JSON.stringify({
          message: err.message,
          stack: err.stack,
          name: err.name,
        }) + " " + formattedDateTime());
        this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: this.$t('general-err-msg') });
      }
      if (this.$refs.remarkTextAreas && this.$refs.remarkTextAreas.length > 0) {
        this.$refs.remarkTextAreas.forEach((textarea) => {
          this.adjustHeight(textarea);
        });
      }

    },

  },
  mounted() {
    if (this.$refs.remarkTextAreas && this.$refs.remarkTextAreas.length > 0) {
      this.$refs.remarkTextAreas.forEach((textarea) => {
        this.adjustHeight(textarea);
      });
    }
  },
  created() {
    this.displayedLastWeight = this.lastWeight;

    this.$root.$on('close-cali-popup' + this.selectedMember.id, this.calibrationPopup);
  },
  beforeDestroy() {
    this.$root.$off('close-cali-popup' + this.selectedMember.id, this.calibrationPopup);
  },
  watch: {
    displayedLastWeight: {
      handler(newVal) {
        if (newVal) {
          this.updateLastWeight(newVal);
        }
      }
    },
    'newRemarkValue': {
      deep: true, // Watch for changes in nested properties
      handler(newVal) {
        const isValueInArray = this.originalMember.remarks.find(remark => remark.text == newVal);
        if (!isValueInArray) {
          if (!this.isRemarksChanged) {
            this.isRemarksChanged = true;
          }
        } else {
          this.isRemarksChanged = false;
        }
      }
    },
  }
};
</script>

<style>
/*  some classes can be in Session component */
.birthday {
  background-color: var(--fit20-pink);
  color: white;
  font-size: 11px;
  border-radius: 3px;
  padding: 3px 5px 1px 5px;
  color: white;
  text-align: center;
  width: 13ch;
  margin-left: 5px;
}

/* .member-birthday {
  padding: 2px 5px 1px 5px;
} */

.session-l {
  width: 28%;
  position: relative;
}

.qs-container {
  width: 100%;
  height: 145px;
  margin-top: -65PX;
}

.member-img-div {
  position: relative;
  border-radius: 10px;
  width: 61px;
  height: 61px;
}

.member-age {
  font-size: 11px;
  background-color: var(--fit20-blue);
  border-radius: 3px;
  padding: 3px 5px 1px 5px;
  color: white;
  text-align: center;
  width: 6ch;
  margin-left: 10px;
}

.member-img-div>.member-img {
  border-radius: 10px;
}

.session-img-ico {
  position: absolute;
  bottom: 1px;
  right: 0px;
  width: 30px;
}

.member-name {
  color: var(--fit20-blue);
  font-family: 'VAG light', Verdana, Geneva, Tahoma, sans-serif;
  padding-left: 10px;
  margin-top: 5px;
  font-size: 14px;
}

.edit-member {
  background-color: white;
  border-radius: 10px;
  width: 70%;
}

.edit-member-body {
  margin-top: 5px;
  padding-bottom: 10px;
}

.edit-member-body>form {
  width: 85%;
  padding-left: 10px;
}

.edit-member-1sec>.field-sec {
  width: 48%;
}

.field-sec {
  margin-top: 15px;
}

.field-sec.flex>label {
  padding: 0px 0px 0px 10px;
}

.member-info.flex {
  flex-wrap: nowrap;
}

.session-form-container input,
.session-form-container select,
.session-form-container textarea {
  width: 90%;
  background-color: white;
  padding-left: 5px;
  border-radius: 5px;
  color: black;
  border: solid 1px var(--fit20-lighter-gray);
}

.session-form-container input,
.session-form-container select {
  height: 30px;
  background-color: white;
  padding-left: 5px;
  border-radius: 5px;
  color: black;
  border: solid 1px var(--fit20-lighter-gray);
}

.field-sec.flex>label {
  width: 48%;
}

.field-sec.flex>input {
  width: fit-content;
}

.session-studio-container input.height {
  width: 60px !important;
  text-align: center;
}

.session-studio-container .fake-div {
  height: 88%;
}

.last-measure-weight {
  margin-left: 10px;
}

.measure-div {
  color: var(--fit20-light-gray);
  font-size: 14px;
  max-height: 100px;
  overflow: auto;
}

.measure-date {
  padding-left: 10px;
  width: 100px;
}

.measure-weight {
  padding-left: 20px;
}

.remarks {
  height: 320px;
  overflow-y: scroll;
  border: solid 1px var(--fit20-lighter-gray);
  border-top-right-radius: 10px;
  border-bottom-left-radius: 10px;
  margin-top: 10px;
  padding: 10px 10px 10px 10px;
  position: relative;
  transition: height ease-in 0.5s;
  overflow-x: hidden;
}

.over-write-remarks-height {
  height: 200px;
}

.remarks div:focus {
  outline: none;
}

.remarks .green-heart {
  width: 15px;
}

.remarks .pin {
  width: 18px;
  padding-left: 3px;
}

.remarks-title-sec {
  margin-top: 9px;
  display: flex;
}

.remarks-title {
  font-size: 12px;
  padding-left: 3px;
}

.remarks-type {
  color: var(--fit20-green);
}

.remarks-text {
  font-size: 11px;
  width: 85%;
  margin-top: 3px;
}

.add-remark {
  width: 45px;
  position: sticky;
  right: 5px;
  bottom: 10px;
  margin-left: 80%;
}

.save-remark {
  width: 45px;
  position: absolute;
  right: 0;
  top: 5px;
}

.add-remark-popup {
  height: 100%;
  width: 104%;
  position: absolute;
  background-color: rgb(255, 255, 255);
  top: 0;
  left: -11px;
  z-index: 99;
}

.remarks-popup-title {
  height: 30px;
  background-color: var(--fit20-green);
  text-align: right;
}

.session-studio-container .close-popup {
  width: 30px;
  padding: 5px;
}

select.select-remarks {
  background-color: white;
  padding: 10px;
  border-color: var(--fit20-lighter-gray);
  border-radius: 10px;
  color: var(--fit20-blue);

}

.text-area-remarks {
  display: block;
  margin-top: 10px;
  width: 100%;
  border-color: var(--fit20-lighter-gray);
  border-radius: 10px;

}

.add-remarks-body {
  background-color: white;
  padding: 10px 20px;
}

.save-remarks-btn {
  position: absolute;
  right: 10px;
  width: 50px;
  bottom: 10px;
}

.follow-me-container {
  text-align: center;
  height: 25px;
  background-color: var(--fit20-lighter-gray);
  width: 100%;
  border-radius: 5px;
  position: relative;
  margin-top: 10px;
}

.flash {
  animation: flashAnim 0.8s ease;
}

@keyframes flashAnim {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 1;
  }
}

.follow-me-container::before {
  content: '';
  display: block;
  height: 25px;
  margin-left: 10%;
  position: absolute;
  border-left: dashed 1px white;
  z-index: 5;
}

.follow-me-container::after {
  content: '';
  position: absolute;
  display: block;
  height: 25px;
  margin-left: 90%;
  border-right: dashed 1px white;
  z-index: 5;
}

.stationary-popup-overlay {
  position: fixed;
  top: -65px;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  border-radius: 10px;
}

.rep-counter {
  text-align: start;
  height: 25px;
  position: absolute;
  color: white;
  z-index: 3;
  left: 15%;
  top: 3px;
}

.second-counter {
  text-align: end;
  height: 25px;
  position: absolute;
  color: white;
  z-index: 3;
  left: 80%;
  top: 3px;
}

.blue-cali {
  position: absolute;
  top: 0px;
  left: 35%;
}

.follow-me-bar {
  text-align: center;
  height: 25px;
  position: absolute;
  background-color: var(--fit20-gray);
  border-radius: 5px;
  /* transition: width 0.5s ease; */
}

.you-container {
  border-radius: 5px;
  margin-top: 5px;
  height: 25px;
  background-color: var(--fit20-lighter-gray);
  width: 100%;
  position: relative;
}

.you-container::before {
  content: '';
  display: block;
  height: 25px;
  margin-left: 10%;
  position: absolute;
  border-left: dashed 1px white;
  z-index: 5;
}

.you-container::after {
  content: '';
  position: absolute;
  display: block;
  height: 25px;
  margin-left: 90%;
  border-right: dashed 1px white;
  z-index: 5;
}

.you-bar {
  height: 25px;
  position: absolute;
  border-radius: 5px;
  transition: background-color 0.5s ease;
}

.bars {
  position: relative;
}

.cali {
  position: absolute;
  height: 160px;
  border: solid 2px var(--fit20-blue);
  border-radius: 8px;
  width: 100%;
  top: 0px;
  left: 0;
  background-color: white;
  z-index: 2;
  pointer-events: auto;
}

.cali-close {
  position: absolute;
  right: 10px;
  top: 10px;
}

.cali-close-img-m {
  margin-left: 20px;
}

.cali-img-m {
  margin-left: 15px;
  margin-top: 15px;
}

.stationary-count-down {
  width: 40px;
  height: 40px;
  font-size: 20px;
  border-radius: 50%;
  color: white;
  background-color: var(--fit20-blue);
  text-align: center;
  padding: 25%;
}


path[stroke="#0000002f"] {
  stroke-width: 10px;
}

path[stroke="#009FE380"] {
  stroke-width: 3px;
}

.chart__wrapper {
  margin: 0 !important;
}

.msg {
  text-align: center;
  font-size: 8px;
  color: var(--fit20-light-gray);
}

.member-menu-container {
  position: absolute;
  width: 30px;
  top: 0;
  right: 0;

}

.member-menu {
  width: 70%;
  position: absolute;
  top: 0px;
  right: 0px;
  border: solid 1px var(--fit20-lighter-gray);
  border-radius: 10px;
  background-color: white;
  z-index: 10;
  padding: 10px 5px 10px 5px;
  animation: member-menu-animation .6s;
}

.member-menu-items {
  margin-top: 15px;
  margin-left: 10px;
}

.member-menu-items div {
  margin-bottom: 8px;
  color: var(--fit20-gray);
}

@keyframes member-menu-animation {
  from {
    width: 0;
  }

  to {
    width: 70%;
  }
}

.menu-header .close-member-menu {
  position: absolute;
  right: 0px;
  top: 0px;
  padding: 5px;
}

.training-age {
  text-align: center;
  font-size: 14px;
  color: white;
  background-color: var(--fit20-pink);
  border-radius: 3px;
  margin-top: 5px;
  width: 97%;
}

.unstyled-textarea {
  border: none;
  background: white;
  outline: none;
  resize: none;
  height: auto;
  font-family: 'VAG light', 'Courier New', Courier, monospace;
  font-size: 11px;
}

.remarks-top-m {
  margin-top: -7px;
}
</style>
